import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { FileText, Newspaper, Image as ImageIcon, Inbox } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState({ pages: 0, posts: 0, media: 0, inbox: 0, unread: 0 });
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    Promise.all([
      api.get("/pages"),
      api.get("/blog", { params: { published_only: false } }),
      api.get("/media"),
      api.get("/contact"),
    ]).then(([p, b, m, c]) => {
      setStats({
        pages: (p.data || []).length,
        posts: (b.data || []).length,
        media: (m.data || []).length,
        inbox: (c.data || []).length,
        unread: (c.data || []).filter(x => !x.read).length,
      });
      setRecent((c.data || []).slice(0, 5));
    }).catch(() => {});
  }, []);

  const cards = [
    { label: "Pages", value: stats.pages, icon: FileText, to: "/admin/pages", testid: "stat-pages" },
    { label: "Blog posts", value: stats.posts, icon: Newspaper, to: "/admin/blog", testid: "stat-blog" },
    { label: "Media files", value: stats.media, icon: ImageIcon, to: "/admin/media", testid: "stat-media" },
    { label: "Unread messages", value: stats.unread, icon: Inbox, to: "/admin/inbox", testid: "stat-inbox" },
  ];

  return (
    <div className="p-5 sm:p-8 lg:p-10" data-testid="admin-dashboard">
      <p className="label-eyebrow mb-3">Overview</p>
      <h1 className="font-serif-display text-4xl mb-10 text-[#1a1a1a]">Welcome back.</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-12">
        {cards.map((c) => (
          <Link key={c.label} to={c.to} className="bg-white border border-neutral-200 p-6 hover:border-[#6B1F2A] transition-colors block" data-testid={c.testid}>
            <div className="flex items-start justify-between mb-6">
              <c.icon size={20} className="text-[#6B1F2A]" />
              <span className="font-serif-display text-3xl sm:text-4xl text-[#1a1a1a]">{c.value}</span>
            </div>
            <p className="label-eyebrow text-neutral-500">{c.label}</p>
          </Link>
        ))}
      </div>

      <div className="bg-white border border-neutral-200 p-8">
        <div className="flex items-center justify-between mb-6">
          <h2 className="font-serif-display text-2xl text-[#1a1a1a]">Recent messages</h2>
          <Link to="/admin/inbox" className="text-sm text-[#6B1F2A] hover:underline">View inbox</Link>
        </div>
        {recent.length === 0 ? (
          <p className="text-sm text-neutral-500 italic">No messages yet.</p>
        ) : (
          <ul className="divide-y divide-neutral-200">
            {recent.map((m) => (
              <li key={m.id} className="py-4 flex items-start justify-between gap-6">
                <div>
                  <p className="font-medium text-[#1a1a1a]">{m.name} <span className="text-neutral-400 font-normal">· {m.email}</span></p>
                  <p className="text-sm text-neutral-600 truncate max-w-2xl mt-1">{m.subject || m.message}</p>
                </div>
                <p className="text-xs text-neutral-400 whitespace-nowrap">{new Date(m.created_at).toLocaleString()}</p>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
